import React, { useEffect, useState, useRef} from 'react'
import { STriggerModal } from 'shj-components'
import { DatePicker, Form, Input, message, Select, Switch } from 'antd'
import { useSetState } from 'ahooks'
import dayjs from 'dayjs'
import { cloneDeep, get } from 'lodash-es'
import { trimStr } from '@/utils/data.ts'
import {
  getCompanyList
} from '@/services'
import { getUser } from '@/common/utils'

const FormItem = Form.Item
const { TextArea } = Input
const { RangePicker } = DatePicker

interface IAddOrEditProps {
  reload?: (values: object) => void
  onClose?: (values: object) => void
  record?: object
  open?: boolean
  type?: string
  title?: string
  positionType?: array
  positionDuty?: array
  positionLevel?: array
  resourceTree?: array
}

const ModifyModalDom: React.FC<IAddOrEditProps> = (props: IAddOrEditProps) => {
  const {
    record,
    reload,
    onClose,
    open,
    type,
    title,
    positionType,
    positionDuty,
    positionLevel,
    resourceTree,
  } = props
  const id = record?.id
  const [form] = Form.useForm()
  const { setFieldsValue } = form
  const [submitLoading, setSubmitLoading] = useState<boolean>(false)
  const [loading, setLoading] = useState(false)
  const [comPonyList, setComPonyList] = useState([]);
  const [state, setState] = useSetState<any>({
    submitLoading: false,
    resourceType: [],
    fileList: [],
  })
  const user = getUser() || {}


  useEffect(() => {
    if (record?.id && open) {
      const validTime: any[] = []
      let newRecord = cloneDeep(record)
      getAllDecoCompany();
    }
    return () => {}
  }, [record])


  useEffect(() => {
    getAllDecoCompany();
    return () => {
      
    }
  }, [])

  const getAllDecoCompany = async () => {
    let companyList = await getCompanyList();
    console.log(companyList);
    setComPonyList(companyList || []);
  };



  // 提交
  const onFinish = () => {
    form.validateFields().then((values: any) => {
      console.log(values);
      localStorage.setItem(
        'user',
        JSON.stringify(Object.assign(user, {
          primaryDepartPosition: {
            ...user?.primaryDepartPosition,
            companyCodeDeal: values?.companyCode
          }
        }))
      )
      onClose?.()
      reload?.()
    })
  }

  const closeModal = () => {
    form.resetFields()
    onClose?.()
  }

  return (
    <STriggerModal
      title={record?.id ? `${title}` : `${title}`}
      open={open}
      cancelText="取消"
      okText="提交"
      onOk={onFinish}
      onCancel={closeModal}
      confirmLoading={submitLoading}
      width={700}
      destroyOnClose
    >
      <Form form={form} autoComplete="off" labelAlign={'right'} layout="vertical">
        <Form.Item
          label="分公司"
          name="companyCode"
          rules={[{ required: true, message: '请选择分公司' }]}
        >
          <Select 
          allowClear={true} 
          showSearch 
          placeholder="请选择分公司"
          filterOption={(input, option: any) => {
            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }}
          >
            {comPonyList.map((d: any, i: any) => (
              <Select.Option key={d?.id} value={d?.code}>
                {d?.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </STriggerModal>
  )
}

export default ModifyModalDom
